export function Preferences({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.3333 5.41667H13.3333M5.00001 5.41667H1.66667M18.3333 14.5833H15M6.66667 14.5833H1.66667M11.25 5.41667C11.25 7.0275 9.94417 8.33333 8.33334 8.33333C6.72251 8.33333 5.41667 7.0275 5.41667 5.41667C5.41667 3.80584 6.72251 2.5 8.33334 2.5C9.94417 2.5 11.25 3.80584 11.25 5.41667ZM14.5833 14.5833C14.5833 16.1942 13.2775 17.5 11.6667 17.5C10.0558 17.5 8.75 16.1942 8.75 14.5833C8.75 12.9725 10.0558 11.6667 11.6667 11.6667C13.2775 11.6667 14.5833 12.9725 14.5833 14.5833Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
